var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBlockPerson(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 109.973,
    height: 120.826,
    viewBox: "0 0 109.973 120.826",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5595",
    "data-name": "Group 5595",
    transform: "translate(-909.027 -409.174)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-user",
    "data-name": "Icon awesome-user",
    d: "M51.473,58.826A29.413,29.413,0,1,0,22.06,29.413,29.411,29.411,0,0,0,51.473,58.826Zm20.589,7.353H68.225a40,40,0,0,1-33.5,0H30.884A30.892,30.892,0,0,0,0,97.063v9.559a11.033,11.033,0,0,0,11.03,11.03H91.916a11.033,11.033,0,0,0,11.03-11.03V97.063A30.892,30.892,0,0,0,72.062,66.179Z",
    transform: "translate(909.027 409.174)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5592",
    "data-name": "Group 5592",
    transform: "translate(339.537 266.537)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_611",
    "data-name": "Ellipse 611",
    transform: "translate(629.463 213.463)",
    fill: "#fff",
    stroke: "#f11",
    strokeWidth: 5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 25,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 22.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("line", {
    id: "Line_188",
    "data-name": "Line 188",
    x1: 31.371,
    y2: 31.371,
    transform: "translate(638.777 222.777)",
    fill: "none",
    stroke: "#f11",
    strokeWidth: 5
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlockPerson);
export default __webpack_public_path__ + "static/media/block-person.6033da325e941fb265af824e784d6fec.svg";
export { ForwardRef as ReactComponent };